<template>
  <h2>Messdiener</h2>

  <DataTable :cols="[
                 {title: 'Name', key: 'lastname', type: 'text', sortable: true},
                 {title: 'Vorname', key: 'firstname', type: 'text', sortable: true},
                 {title: 'Aktiv', key: 'active', type: 'checkbox', sortable: true},
                 {title: 'Leiter', key: 'leader', type: 'checkbox', sortable: true},
                 {title: 'Weihrauch', key: 'incense', type: 'checkbox', sortable: true},
                 {title: 'Verträgt Weihrauch', key: 'toleratesIncense', type: 'checkbox', sortable: true},
                 {title: 'Partner', key: 'partners', type: 'text', func: this.altarServerStore.getPartnersList},
                 {title: 'E-Mail', key: 'emails', type: 'text', func: (el) => (el.emails || []).join(', ')},
                 {type: 'inject', key: 'absenceCreate'},
                 {type: 'inject', key: 'edit'},
                 {type: 'inject', key: 'delete'},
             ]"
             :data="altarServerStore.sortedData"
             :store="altarServerStore"
             caption="Liste aller Messdiener:innen"
             @sort="col_key => this.altarServerStore.sort(col_key)"
             @update="el => this.altarServerStore.updateItem(el)">
    <template #absenceCreate="{id}">
      <absence-create-modal :altar-server-id="id" trigger-class="btn-secondary" trigger-icon="edit_calendar"
                            trigger-text=""></absence-create-modal>
    </template>
    <template #edit="{el}">
      <AltarServerCreateEditModal :pass-in-altar-server=el trigger-class="btn-warning" trigger-icon="create"
                                  trigger-text=""></AltarServerCreateEditModal>
    </template>
    <template #delete="{el}">
      <button class="btn btn-danger"
              @click="this.altarServerStore.deleteItem(el, true, el.firstname + ' ' + el.lastname)"><em
          class="align-middle material-icons">delete</em></button>
    </template>
  </DataTable>

  <AltarServerCreateEditModal :pass-in-altar-server="null" trigger-class="btn-success"
                              trigger-icon="create"
                              trigger-text="Neue:n Messdiener:in anlegen"></AltarServerCreateEditModal>

</template>

<script>
import AbsenceCreateModal from "@/components/AbsenceCreateModal";
import AltarServerCreateEditModal from "@/components/AltarServerCreateEditModal";
import {useAltarServerStore} from "@/stores/altarServer";
import DataTable from "@/components/DataTable.vue";

export default {
  name: "AltarServers",
  created() {
    this.altarServerStore.getData();
  },
  components: {
    DataTable,
    AltarServerCreateEditModal,
    AbsenceCreateModal,
  },
  setup() {
    const altarServerStore = useAltarServerStore();
    return {altarServerStore};
  }
}
</script>

<style src="vue-multiselect/dist/vue-multiselect.css"></style>
